export default (state = { online: false }, action) => {
    switch (action.type) {
        case 'ONLINE':
            return { ...state, online: true };
        case 'OFFLINE':
            return { ...state, online: false };
        default:
            return state;
    }
};